import { fechaCierreVigente, fechaEstaCerrada, getParametrosFiscales, saveData, siguienteNumeroDoc , saveParametrosFiscales} from "../core/cloudSync.js";
import { exportCertificadoRetencion } from "../export/pdf.js";

import { getTipoCuentaPUC } from "../core/accounting.js";
import { C, CONCEPTOS_1001, CUENTAS_RETENCION, DOC_INFO, EXOGENA_FORMATOS } from "../core/config.js";
import { state } from "../core/state.js";
import { btnStyle, escapeHTML, fmtCOP, fmtDate, inputStyle, parseNumber, today , parsePct} from "../core/utils.js";
import { render } from "../ui/app.js";
import { getSaldoFactura } from "./facturas.js";
import { getSaldoOCP } from "./documentos.js";

export function renderCuentaPUCModal() {
  const c = state.editingCuentaPUC;
  state.modal = `
    <div data-action="close-modal-bg" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.45);display:flex;align-items:center;justify-content:center;z-index:1000;padding:11px;">
      <div data-action="prevent-close" style="background:white;border-radius:14px;width:420px;max-width:100%;box-shadow:0 20px 60px rgba(0,0,0,.2);">
        <div style="padding:10px 12px;border-bottom:1px solid ${C.border};background:linear-gradient(135deg,#0E749015,#0E749008);">
          <h3 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">${c._isNew ? "➕ Nueva cuenta PUC" : "✏️ Editar cuenta PUC"}</h3>
        </div>
        <div style="padding:11px;">
          <div style="margin-bottom:12px;">
            <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Código (4-6 dígitos)</label>
            <input id="puc-codigo" value="${escapeHTML(c.codigo)}" placeholder="Ej: 1110" style="${inputStyle}" oninput="state.editingCuentaPUC.codigo=this.value;"/>
          </div>
          <div style="margin-bottom:12px;">
            <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Nombre de la cuenta</label>
            <input id="puc-nombre" value="${escapeHTML(c.nombre)}" placeholder="Ej: Bancos" style="${inputStyle}" oninput="state.editingCuentaPUC.nombre=this.value;"/>
          </div>
          <div style="margin-bottom:12px;">
            <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">Naturaleza</label>
            <select id="puc-naturaleza" style="${inputStyle}cursor:pointer;" onchange="state.editingCuentaPUC.naturaleza=this.value;">
              <option value="D" ${c.naturaleza==="D"?"selected":""}>Débito (Activos, Gastos, Costos)</option>
              <option value="C" ${c.naturaleza==="C"?"selected":""}>Crédito (Pasivos, Patrimonio, Ingresos)</option>
            </select>
          </div>
          <div style="display:flex;gap:10px;justify-content:flex-end;padding-top:14px;border-top:1px solid ${C.border};">
            <button data-action="close-modal" style="${btnStyle(null,"secondary")}">Cancelar</button>
            <button data-action="save-cuenta-puc" style="${btnStyle("#0E7490")}">💾 Guardar</button>
          </div>
        </div>
      </div>
    </div>
  `;
  render();
}

export function renderContabilidad() {
  if (!state.contabTab) state.contabTab = "diario";
  // Facturas de Proveedor se mudó a Compras: si quedó seleccionada de antes,
  // se cae a Libro Diario en vez de mostrar una pestaña que ya no existe.
  if (state.contabTab === "fact_prov") state.contabTab = "diario";
  const tab = state.contabTab;

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">🧮 Contabilidad</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Plan Único de Cuentas (PUC), Libro Diario y Libro Mayor — causación automática NIIF Grupo 2 / Decreto 2650 de 1993</p>
        </div>
      </div>
      <div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;">
        <button onclick="exportarExcelLibroDiario()" style="background:#0E7490;color:white;border:none;padding:7px 13px;border-radius:7px;font-weight:700;cursor:pointer;font-size:10.5px;white-space:nowrap;">📥 Libro Diario</button>
        <button onclick="exportarExcelBalancePrueba()" style="background:#0E7490;color:white;border:none;padding:7px 13px;border-radius:7px;font-weight:700;cursor:pointer;font-size:10.5px;white-space:nowrap;">📥 Balance</button>
        <button onclick="exportarExcelEstadoResultados()" style="background:#0E7490;color:white;border:none;padding:7px 13px;border-radius:7px;font-weight:700;cursor:pointer;font-size:10.5px;white-space:nowrap;">📥 Resultados</button>
      </div>
    </div>
  `;

  const tabs = [
    { id:"diario", label:"📒 Libro Diario" },
    { id:"mayor", label:"📚 Libro Mayor" },
    { id:"balance", label:"⚖️ Balance de Prueba" },
    { id:"resultados", label:"📈 Estado de Resultados" },
    { id:"situacion", label:"🏛️ Situación Financiera" },
    { id:"retenciones", label:"🧾 Retenciones" },
    { id:"iva", label:"🧮 IVA / DIAN" },
    { id:"exogena", label:"📤 Exógena" },
    { id:"puc", label:"🗂️ Plan de Cuentas (PUC)" }
  ].map(t => `
    <button data-action="contab-tab" data-tab="${t.id}" style="
      padding:10px 18px;background:${tab===t.id?"white":"transparent"};
      border:none;border-bottom:3px solid ${tab===t.id?C.accent:"transparent"};
      color:${tab===t.id?"#0E7490":C.muted};font-weight:700;font-size:12px;cursor:pointer;margin-bottom:-1px;font-family:inherit;
    ">${t.label}</button>
  `).join("");

  let body;
  if (tab === "puc") body = renderPUCTab();
  else if (tab === "mayor") body = renderLibroMayorTab();
  else if (tab === "balance") body = renderBalancePruebaTab();
  else if (tab === "resultados") body = renderEstadoResultadosTab();
  else if (tab === "situacion") body = renderSituacionFinancieraTab();
  else if (tab === "retenciones") body = renderRetencionesTab();
  else if (tab === "iva") body = renderIVATab();
  else if (tab === "exogena") body = renderExogenaTab();
  else body = renderLibroDiarioTab();

  return `
    ${header}
    <div style="display:flex;gap:6px;margin-bottom:18px;border-bottom:1px solid ${C.border};">${tabs}</div>
    ${body}
  `;
}

export function getSaldoCuentaRango(codigo, desde, hasta) {
  const cuenta = (state.data.puc||[]).find(c => c.codigo === codigo);
  let debito = 0, credito = 0;
  (state.data.asientos||[]).forEach(a => {
    if (desde && a.fecha < desde) return;
    if (hasta && a.fecha > hasta) return;
    (a.movimientos||[]).forEach(m => {
      if (m.cuenta === codigo) { debito += m.debito; credito += m.credito; }
    });
  });
  const naturaleza = cuenta ? cuenta.naturaleza : "D";
  const saldo = naturaleza === "D" ? debito - credito : credito - debito;
  return { debito, credito, saldo, naturaleza };
}

export function getSaldoClase(prefijo, desde, hasta) {
  let total = 0;
  (state.data.puc||[]).forEach(c => {
    if (c.codigo.startsWith(prefijo)) total += getSaldoCuentaRango(c.codigo, desde, hasta).saldo;
  });
  return total;
}

export function calcularEstadoResultados(desde, hasta) {
  // Ingresos operacionales: grupo 41 (ventas 4135 + servicios 4155). Las cuentas
  // 4175/4180 son contra-ingreso (naturaleza D) y se restan como devoluciones.
  const ingresosOperacionales = getSaldoCuentaRango("4135", desde, hasta).saldo + getSaldoCuentaRango("4155", desde, hasta).saldo;
  const devoluciones = getSaldoCuentaRango("4175", desde, hasta).saldo + getSaldoCuentaRango("4180", desde, hasta).saldo;
  const ingresosNetos = ingresosOperacionales - devoluciones;
  const costoVentas = getSaldoClase("61", desde, hasta);
  const utilidadBruta = ingresosNetos - costoVentas;
  // Gastos operacionales: administración (51) + ventas (52) completos
  const gastosOperacionales = getSaldoClase("51", desde, hasta) + getSaldoClase("52", desde, hasta);
  const utilidadOperacional = utilidadBruta - gastosOperacionales;
  const ingresosFinancieros = getSaldoClase("42", desde, hasta);
  const gastosFinancieros = getSaldoClase("53", desde, hasta);
  const utilidadAntesImpuesto = utilidadOperacional + ingresosFinancieros - gastosFinancieros;
  // Impuesto de renta: si ya está CONTABILIZADO (clase 54, p. ej. la provisión
  // registrada desde esta pantalla), se usa ese valor real; si no, se estima
  // con la tarifa de Parámetros Fiscales — y se dice que es una estimación.
  const rentaContabilizada = getSaldoClase("54", desde, hasta);
  const tasaRenta = (parseNumber(getParametrosFiscales().renta_pct) || 35) / 100;
  const rentaEstimada = rentaContabilizada > 0.5 ? false : true;
  const provisionRenta = rentaContabilizada > 0.5
    ? rentaContabilizada
    : (utilidadAntesImpuesto > 0 ? Math.round(utilidadAntesImpuesto * tasaRenta) : 0);
  const utilidadNeta = utilidadAntesImpuesto - provisionRenta;
  return { ingresosOperacionales, devoluciones, ingresosNetos, costoVentas, utilidadBruta,
           gastosOperacionales, utilidadOperacional, ingresosFinancieros, gastosFinancieros,
           utilidadAntesImpuesto, provisionRenta, rentaEstimada, tasaRenta, utilidadNeta };
}

export function renderBalancePruebaTab() {
  if (!state.contabFiltros) state.contabFiltros = { desde:"", hasta:"" };
  const f = state.contabFiltros;
  const puc = [...(state.data.puc||[])].sort((a,b) => a.codigo.localeCompare(b.codigo));

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Desde</label>
        <input type="date" value="${f.desde}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.desde=this.value;render();"/>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Hasta</label>
        <input type="date" value="${f.hasta}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.hasta=this.value;render();"/>
      </div>
      <div style="font-size:10px;color:${C.muted};">Si dejas las fechas vacías, se calcula desde el inicio de operaciones.</div>
    </div>
  `;

  let totalDeb = 0, totalCred = 0, totalSaldoDeb = 0, totalSaldoCred = 0;
  const filas = puc.map(c => {
    const r = getSaldoCuentaRango(c.codigo, f.desde, f.hasta);
    totalDeb += r.debito;
    totalCred += r.credito;
    const saldoDeudor = r.saldo > 0 && c.naturaleza === "D" ? r.saldo : (r.saldo < 0 && c.naturaleza === "C" ? -r.saldo : 0);
    const saldoAcreedor = r.saldo > 0 && c.naturaleza === "C" ? r.saldo : (r.saldo < 0 && c.naturaleza === "D" ? -r.saldo : 0);
    totalSaldoDeb += saldoDeudor;
    totalSaldoCred += saldoAcreedor;
    return { c, r, saldoDeudor, saldoAcreedor };
  }).filter(f => f.r.debito !== 0 || f.r.credito !== 0);

  if (filas.length === 0) {
    return filtersHTML + `<div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">Sin movimientos en el período seleccionado.</div>`;
  }

  return filtersHTML + `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Código</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Cuenta</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Movimiento débito</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Movimiento crédito</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Saldo deudor</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Saldo acreedor</th>
        </tr></thead>
        <tbody>
          ${filas.map(x => `
            <tr style="border-top:1px solid ${C.border};">
              <td style="padding:6px 10px;font-weight:700;">${escapeHTML(x.c.codigo)}</td>
              <td style="padding:6px 10px;">${escapeHTML(x.c.nombre)}</td>
              <td style="padding:6px 10px;text-align:right;">${x.r.debito ? fmtCOP(x.r.debito) : ""}</td>
              <td style="padding:6px 10px;text-align:right;">${x.r.credito ? fmtCOP(x.r.credito) : ""}</td>
              <td style="padding:6px 10px;text-align:right;font-weight:700;">${x.saldoDeudor ? fmtCOP(x.saldoDeudor) : ""}</td>
              <td style="padding:6px 10px;text-align:right;font-weight:700;">${x.saldoAcreedor ? fmtCOP(x.saldoAcreedor) : ""}</td>
            </tr>
          `).join("")}
        </tbody>
        <tfoot>
          <tr style="border-top:2px solid ${C.border};font-weight:800;background:#f9fafb;">
            <td colspan="2" style="padding:6px 10px;">TOTALES</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totalDeb)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totalCred)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totalSaldoDeb)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totalSaldoCred)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    ${Math.abs(totalSaldoDeb-totalSaldoCred) > 1 ? `<div style="margin-top:10px;padding:10px;background:#fee2e2;border-radius:6px;color:#dc2626;font-size:11.5px;font-weight:700;">⚠️ El balance no cuadra: diferencia de ${fmtCOP(Math.abs(totalSaldoDeb-totalSaldoCred))}. Revisa los asientos con descuadre en el Libro Diario.</div>` : ""}
  `;
}

export function renderEstadoResultadosTab() {
  if (!state.contabFiltros) state.contabFiltros = { desde:"", hasta:"" };
  const f = state.contabFiltros;
  const r = calcularEstadoResultados(f.desde, f.hasta);

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Desde</label>
        <input type="date" value="${f.desde}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.desde=this.value;render();"/>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Hasta</label>
        <input type="date" value="${f.hasta}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.hasta=this.value;render();"/>
      </div>
    </div>
  `;

  const fila = (label, valor, opts={}) => `
    <tr style="border-top:1px solid ${C.border};${opts.bold?"font-weight:800;background:#f9fafb;":""}">
      <td style="padding:6px 10px;${opts.indent?"padding-left:28px;":""}">${label}</td>
      <td style="padding:6px 10px;text-align:right;${valor<0?"color:#dc2626;":""}">${fmtCOP(valor)}</td>
    </tr>
  `;

  const tasaRentaPct = Math.round(r.tasaRenta * 1000) / 10;   // la tarifa de Parámetros Fiscales
  const amber = C.amber;

  const rentaCard = r.utilidadAntesImpuesto > 0 ? `
    <div style="background:white;border:1px solid ${amber}40;border-radius:6px;padding:18px 20px;margin-top:16px;max-width:560px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;">
        <div style="font-weight:800;font-size:14px;color:${C.text};">🏛️ Provisión Impuesto de Renta</div>
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;">
          Tarifa ${tasaRentaPct}% — se cambia en <span data-action="ir-parametros-fiscales" style="color:#0E7490;font-weight:700;cursor:pointer;text-decoration:underline;">Parámetros Fiscales</span>
        </div>
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:9px;">
        <div style="background:#f8fafc;border-radius:6px;padding:9px;">
          <div style="font-size:10px;font-weight:700;color:${C.muted};margin-bottom:4px;">UTILIDAD ANTES DE IMPUESTO</div>
          <div style="font-size:12px;font-weight:800;color:${C.text};">${fmtCOP(r.utilidadAntesImpuesto)}</div>
        </div>
        <div style="background:#fef3c7;border-radius:6px;padding:9px;">
          <div style="font-size:10px;font-weight:700;color:#92400e;margin-bottom:4px;">${r.rentaEstimada ? `PROVISIÓN ESTIMADA (${tasaRentaPct}%)` : "IMPUESTO DE RENTA CONTABILIZADO (54)"}</div>
          <div style="font-size:12px;font-weight:800;color:#b45309;">${fmtCOP(r.provisionRenta)}</div>
        </div>
        <div style="background:#d1fae5;border-radius:6px;padding:9px;">
          <div style="font-size:10px;font-weight:700;color:#065f46;margin-bottom:4px;">UTILIDAD NETA DESPUÉS DE IMPUESTO</div>
          <div style="font-size:12px;font-weight:800;color:#065f46;">${fmtCOP(r.utilidadNeta)}</div>
        </div>
      </div>
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <div style="font-size:10.5px;color:${C.muted};line-height:1.5;">
          Asiento: <strong>Db 5405</strong> Impuesto de renta y complementarios /
          <strong>Cr 2615</strong> Impuesto a las ganancias por pagar<br/>
          <span style="font-size:10px;">Tarifa régimen ordinario 2024: 35% | SIMPLE: varía según actividad e ingresos</span>
        </div>
        ${r.rentaEstimada ? `<button data-action="generar-provision-renta"
          data-desde="${f.desde}" data-hasta="${f.hasta}" data-valor="${r.provisionRenta}"
          style="${btnStyle(amber)};white-space:nowrap;">💾 Generar asiento</button>`
          : `<span style="font-size:10.5px;font-weight:700;color:#065f46;background:#d1fae5;border-radius:6px;padding:6px 10px;">✅ Ya contabilizado</span>`}
      </div>
    </div>
  ` : `<div style="margin-top:16px;max-width:560px;padding:12px 16px;background:#f1f5f9;border-radius:6px;font-size:11.5px;color:${C.muted};">
    ℹ️ No hay utilidad en el período — sin provisión de impuesto de renta.
  </div>`;

  return filtersHTML + `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;max-width:560px;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Concepto</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Valor</th>
        </tr></thead>
        <tbody>
          ${fila("Ingresos operacionales (grupo 41)", r.ingresosOperacionales)}
          ${fila("(–) Devoluciones y descuentos en ventas (4175/4180)", -r.devoluciones, {indent:true})}
          ${fila("= Ingresos netos", r.ingresosNetos, {bold:true})}
          ${fila("(–) Costo de ventas (grupo 61)", -r.costoVentas, {indent:true})}
          ${fila("= Utilidad bruta", r.utilidadBruta, {bold:true})}
          ${fila("(–) Gastos operacionales (grupos 51 y 52)", -r.gastosOperacionales, {indent:true})}
          ${fila("= Utilidad operacional", r.utilidadOperacional, {bold:true})}
          ${fila("(+) Ingresos no operacionales (grupo 42)", r.ingresosFinancieros, {indent:true})}
          ${fila("(–) Gastos financieros (grupo 53)", -r.gastosFinancieros, {indent:true})}
          ${fila("= Utilidad antes de impuesto de renta", r.utilidadAntesImpuesto, {bold:true})}
          ${r.provisionRenta > 0 ? fila(r.rentaEstimada ? "(–) Provisión impuesto de renta ESTIMADA (" + tasaRentaPct + "%)" : "(–) Impuesto de renta contabilizado (clase 54)", -r.provisionRenta, {indent:true}) : ""}
          ${fila("= UTILIDAD NETA DEL PERÍODO", r.utilidadNeta, {bold:true})}
        </tbody>
      </table>
    </div>
  ` + rentaCard;
}

export function renderSituacionFinancieraTab() {
  if (!state.contabFiltros) state.contabFiltros = { desde:"", hasta:"" };
  const hasta = state.contabFiltros.hasta || today();

  // ── Construido COMPLETO desde el libro, cuenta por cuenta ────────────────
  // Antes era una lista escogida a mano (caja, clientes, inventario, unos
  // pasivos…): en cuanto aparecían nómina, anticipos de clientes, activos
  // fijos o provisiones, esas cuentas no salían y el estado no cuadraba.
  // Ahora se listan TODAS las cuentas con saldo de las clases 1, 2 y 3, y el
  // resultado del ejercicio es el CONTABLE (clases 4 − 5 − 6 − 7 del libro),
  // así Activo = Pasivo + Patrimonio siempre, por construcción.
  const cuentasClase = (clase) => (state.data.puc||[])
    .filter(c => c.codigo.startsWith(clase))
    .map(c => ({ ...c, r: getSaldoCuentaRango(c.codigo, "", hasta) }))
    .filter(c => Math.abs(c.r.saldo) > 0.5)
    .sort((a,b) => a.codigo.localeCompare(b.codigo));

  const activos = cuentasClase("1");
  const pasivos = cuentasClase("2");
  const patrimonio = cuentasClase("3");
  const totalActivos = activos.reduce((s,c)=>s+c.r.saldo,0);
  const totalPasivos = pasivos.reduce((s,c)=>s+c.r.saldo,0);
  const capitalYReservas = patrimonio.reduce((s,c)=>s+c.r.saldo,0);
  // Resultado contable del ejercicio: ingresos (4) − gastos (5) − costos (6 y 7).
  const resultadoEjercicio = getSaldoClase("4","",hasta) - getSaldoClase("5","",hasta)
    - getSaldoClase("6","",hasta) - getSaldoClase("7","",hasta);
  const totalPatrimonio = capitalYReservas + resultadoEjercicio;

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Estado de situación financiera a fecha</label>
        <input type="date" value="${hasta}" style="${inputStyle}width:170px;" onchange="state.contabFiltros.hasta=this.value;render();"/>
      </div>
      <div style="font-size:10px;color:${C.muted};">Incluye todas las cuentas con saldo. El resultado del ejercicio es el contable (libro), no una estimación.</div>
    </div>
  `;

  const fila = (label, valor, opts={}) => `
    <tr style="border-top:1px solid ${C.border};${opts.bold?"font-weight:800;background:#f9fafb;":""}">
      <td style="padding:6px 10px;${opts.indent?"padding-left:28px;":""}">${label}</td>
      <td style="padding:6px 10px;text-align:right;">${fmtCOP(valor)}</td>
    </tr>
  `;
  const filasCuentas = (lista) => lista.map(c =>
    fila(`${escapeHTML(c.codigo)} — ${escapeHTML(c.nombre)}`, c.r.saldo, {indent:true})).join("");

  const diferencia = totalActivos - (totalPasivos + totalPatrimonio);

  return filtersHTML + `
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;align-items:start;">
      <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead><tr style="background:#e4eaf5;"><th colspan="2" style="padding:6px 10px;text-align:left;font-size:11.5px;font-weight:800;color:#1e40af;">ACTIVOS</th></tr></thead>
          <tbody>
            ${filasCuentas(activos) || fila("Sin movimientos", 0, {indent:true})}
            ${fila("TOTAL ACTIVOS", totalActivos, {bold:true})}
          </tbody>
        </table>
      </div>
      <div style="display:flex;flex-direction:column;gap:10px;">
        <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
          <table style="width:100%;border-collapse:collapse;font-size:12px;">
            <thead><tr style="background:#fee2e2;"><th colspan="2" style="padding:6px 10px;text-align:left;font-size:11.5px;font-weight:800;color:#991b1b;">PASIVOS</th></tr></thead>
            <tbody>
              ${filasCuentas(pasivos) || fila("Sin movimientos", 0, {indent:true})}
              ${fila("TOTAL PASIVOS", totalPasivos, {bold:true})}
            </tbody>
          </table>
        </div>
        <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
          <table style="width:100%;border-collapse:collapse;font-size:12px;">
            <thead><tr style="background:#d1fae5;"><th colspan="2" style="padding:6px 10px;text-align:left;font-size:11.5px;font-weight:800;color:#065f46;">PATRIMONIO</th></tr></thead>
            <tbody>
              ${filasCuentas(patrimonio)}
              ${fila("Resultados del ejercicio (contable)", resultadoEjercicio, {indent:true})}
              ${fila("TOTAL PATRIMONIO", totalPatrimonio, {bold:true})}
            </tbody>
          </table>
        </div>
        <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:6px 10px;font-weight:800;display:flex;justify-content:space-between;">
          <span>TOTAL PASIVO + PATRIMONIO</span><span>${fmtCOP(totalPasivos+totalPatrimonio)}</span>
        </div>
      </div>
    </div>
    ${Math.abs(diferencia) > 1 ? `<div style="margin-top:10px;padding:10px;background:#fee2e2;border-radius:6px;color:#dc2626;font-size:11.5px;font-weight:700;">⚠️ Activos ≠ Pasivos + Patrimonio. Diferencia: ${fmtCOP(diferencia)}. Hay asientos descuadrados: revísalos en el Libro Diario.</div>` : `<div style="margin-top:10px;padding:10px;background:#d1fae5;border-radius:6px;color:#065f46;font-size:11.5px;font-weight:700;">✅ Activos = Pasivos + Patrimonio</div>`}
  `;
}

export function renderPUCTab() {
  const puc = [...(state.data.puc||[])].sort((a,b) => a.codigo.localeCompare(b.codigo));
  const rows = puc.map(c => `
    <tr style="border-top:1px solid ${C.border};">
      <td style="padding:6px 10px;font-weight:700;color:${C.text};">${escapeHTML(c.codigo)}</td>
      <td style="padding:6px 10px;">${escapeHTML(c.nombre)}</td>
      <td style="padding:6px 10px;color:${C.muted};">${getTipoCuentaPUC(c.codigo)}</td>
      <td style="padding:6px 10px;text-align:center;">${c.naturaleza === "D" ? "Débito" : "Crédito"}</td>
      <td style="padding:6px 10px;text-align:right;white-space:nowrap;">
        <button data-action="edit-cuenta-puc" data-codigo="${c.codigo}" style="${btnStyle(null,"ghost",true)}">✏️</button>
        <button data-action="delete-cuenta-puc" data-codigo="${c.codigo}" style="${btnStyle(null,"ghost",true)}">🗑</button>
      </td>
    </tr>
  `).join("");

  return `
    <div style="display:flex;justify-content:flex-end;margin-bottom:12px;">
      <button data-action="new-cuenta-puc" style="${btnStyle("#0E7490")}">+ Nueva cuenta</button>
    </div>
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Código</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Nombre de la cuenta</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Clase</th>
          <th style="padding:6px 10px;text-align:center;font-size:10.5px;font-weight:700;color:${C.text};">Naturaleza</th>
          <th style="padding:6px 10px;"></th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
  `;
}

export function getRetencionesDetalle(desde, hasta) {
  const detalle = [];
  (state.data.asientos||[]).forEach(a => {
    if (desde && a.fecha < desde) return;
    if (hasta && a.fecha > hasta) return;
    const retMovs = (a.movimientos||[]).filter(m => CUENTAS_RETENCION[m.cuenta] && m.credito > 0);
    if (retMovs.length === 0) return;
    let ocp = null;
    if (a.origen && a.origen.tipo === "OCP") ocp = (state.data.ocp||[]).find(o => o.id === a.origen.id);
    retMovs.forEach(m => {
      const cfg = CUENTAS_RETENCION[m.cuenta];
      const base = ocp ? (cfg.base === "iva" ? (parseNumber(ocp.iva)||0) : (parseNumber(ocp.subtotal)||0)) : 0;
      const tarifa = base > 0 ? (m.credito / base * 100) : 0;
      detalle.push({ fecha:a.fecha, tercero_id:m.tercero_id, cuenta:m.cuenta, origen:a.origen, base, tarifa, valor:m.credito });
    });
  });
  return detalle;
}

export function renderRetencionesTab() {
  if (!state.contabFiltros) state.contabFiltros = { desde:"", hasta:"" };
  const f = state.contabFiltros;
  const anioActual = parseInt(today().slice(0, 4), 10);   // año en fecha de Colombia, no UTC
  const desde = f.desde || `${anioActual}-01-01`;
  const hasta = f.hasta || `${anioActual}-12-31`;

  const detalle = getRetencionesDetalle(desde, hasta);

  // Agrupar por tercero
  const porTercero = {};
  detalle.forEach(d => {
    const id = d.tercero_id || "sin_tercero";
    if (!porTercero[id]) porTercero[id] = { "2365":0, "2367":0, "2368":0, total:0 };
    porTercero[id][d.cuenta] += d.valor;
    porTercero[id].total += d.valor;
  });

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Desde</label>
        <input type="date" value="${desde}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.desde=this.value;render();"/>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Hasta</label>
        <input type="date" value="${hasta}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.hasta=this.value;render();"/>
      </div>
      <div style="font-size:10px;color:${C.muted};">Las retenciones se causan automáticamente al registrar la factura del proveedor (Compras → Facturas Proveedor), según el % configurado en cada tercero.</div>
    </div>
  `;

  const ids = Object.keys(porTercero);
  if (ids.length === 0) {
    return filtersHTML + `<div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">Sin retenciones causadas en el período.</div>`;
  }

  let totRF=0, totIVA=0, totICA=0, totGen=0;
  const filas = ids.map(id => {
    const prov = (state.data.proveedores||[]).find(p => p.id === id) || {};
    const r = porTercero[id];
    totRF += r["2365"]; totIVA += r["2367"]; totICA += r["2368"]; totGen += r.total;
    return `
      <tr style="border-top:1px solid ${C.border};">
        <td style="padding:6px 10px;font-weight:700;">${escapeHTML(prov.nombre || "Tercero sin identificar")}</td>
        <td style="padding:6px 10px;color:${C.muted};">${escapeHTML(prov.nit||"—")}</td>
        <td style="padding:6px 10px;text-align:right;">${r["2365"] ? fmtCOP(r["2365"]) : "—"}</td>
        <td style="padding:6px 10px;text-align:right;">${r["2367"] ? fmtCOP(r["2367"]) : "—"}</td>
        <td style="padding:6px 10px;text-align:right;">${r["2368"] ? fmtCOP(r["2368"]) : "—"}</td>
        <td style="padding:6px 10px;text-align:right;font-weight:700;">${fmtCOP(r.total)}</td>
        <td style="padding:6px 10px;text-align:center;"><button data-action="ver-certificado-retencion" data-id="${id}" data-desde="${desde}" data-hasta="${hasta}" style="${btnStyle("#0E7490",null,true)}">📄 Certificado</button></td>
      </tr>
    `;
  }).join("");

  return filtersHTML + `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Proveedor / Tercero</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">NIT</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">ReteFuente</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">ReteIVA</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">ReteICA</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Total retenido</th>
          <th style="padding:6px 10px;"></th>
        </tr></thead>
        <tbody>${filas}</tbody>
        <tfoot>
          <tr style="border-top:2px solid ${C.border};font-weight:800;background:#f9fafb;">
            <td colspan="2" style="padding:6px 10px;">TOTALES</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totRF)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totIVA)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totICA)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totGen)}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  `;
}

export function renderAsientoManualModal(draft) {
  const puc = (state.data.puc||[]).sort((a,b)=>a.codigo.localeCompare(b.codigo));
  const totD = draft.movimientos.reduce((s,m)=>s+(parseNumber(m.debito)||0),0);
  const totC = draft.movimientos.reduce((s,m)=>s+(parseNumber(m.credito)||0),0);
  const diff = totD - totC;

  const filas = draft.movimientos.map((m, i) => `
    <tr>
      <td style="padding:4px 6px;">
        <select style="${inputStyle}width:100%;min-width:200px;font-size:11.5px;"
          onchange="state._asientoManualDraft.movimientos[${i}].cuenta=this.value">
          <option value="">— Cuenta —</option>
          ${puc.map(c=>`<option value="${c.codigo}" ${m.cuenta===c.codigo?"selected":""}>${c.codigo} — ${escapeHTML(c.nombre)}</option>`).join("")}
        </select>
      </td>
      <td style="padding:4px 6px;">
        <input style="${inputStyle}width:100%;font-size:11.5px;" value="${escapeHTML(m.descripcion||"")}" placeholder="Descripción"
          onchange="state._asientoManualDraft.movimientos[${i}].descripcion=this.value"/>
      </td>
      <td style="padding:4px 6px;">
        <input type="number" step="1" style="${inputStyle}width:110px;text-align:right;font-size:11.5px;" value="${m.debito||""}" placeholder="0"
          onchange="state._asientoManualDraft.movimientos[${i}].debito=parseFloat(this.value)||0"/>
      </td>
      <td style="padding:4px 6px;">
        <input type="number" step="1" style="${inputStyle}width:110px;text-align:right;font-size:11.5px;" value="${m.credito||""}" placeholder="0"
          onchange="state._asientoManualDraft.movimientos[${i}].credito=parseFloat(this.value)||0"/>
      </td>
      <td style="padding:4px 6px;">
        ${draft.movimientos.length > 2
          ? `<button data-action="asiento-manual-del-linea" data-idx="${i}" style="${btnStyle('#dc2626',null,true)}" title="Eliminar fila">🗑</button>`
          : ""}
      </td>
    </tr>
  `).join("");

  return `
    <div data-action="asiento-manual-cancelar" style="position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(15,23,42,.5);display:flex;align-items:center;justify-content:center;z-index:999;">
      <div onclick="event.stopPropagation()" style="background:white;border-radius:14px;box-shadow:0 20px 60px rgba(0,0,0,.25);width:min(92vw,860px);max-height:90vh;overflow-y:auto;">
        <div style="padding:20px 24px;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;">
          <div>
            <div style="font-size:16px;font-weight:800;color:${C.text};">✏️ Nuevo Asiento Manual</div>
            <div style="font-size:10.5px;color:${C.muted};margin-top:2px;">Se registra en el Libro Diario con prefijo MAN-</div>
          </div>
          <button data-action="asiento-manual-cancelar" style="${btnStyle(null,'ghost',true)}">✕</button>
        </div>
        <div style="padding:16px 24px;border-bottom:1px solid ${C.border};display:flex;gap:10px;flex-wrap:wrap;">
          <div>
            <label style="font-size:10px;font-weight:700;color:${C.muted};display:block;margin-bottom:3px;">FECHA</label>
            <input type="date" value="${draft.fecha}" style="${inputStyle}width:150px;"
              onchange="state._asientoManualDraft.fecha=this.value"/>
          </div>
          <div style="flex:1;min-width:200px;">
            <label style="font-size:10px;font-weight:700;color:${C.muted};display:block;margin-bottom:3px;">CONCEPTO</label>
            <input value="${escapeHTML(draft.concepto||"")}" style="${inputStyle}width:100%;" placeholder="Ej: Depreciación mensual activos fijos"
              onchange="state._asientoManualDraft.concepto=this.value"/>
          </div>
        </div>
        <div style="padding:16px 24px;">
          <div style="overflow-x:auto;">
            <table style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead><tr style="background:#f8fafc;">
                <th style="padding:7px 6px;text-align:left;font-size:10px;font-weight:700;">CUENTA PUC</th>
                <th style="padding:7px 6px;text-align:left;font-size:10px;font-weight:700;">DESCRIPCIÓN</th>
                <th style="padding:7px 6px;text-align:right;font-size:10px;font-weight:700;color:#16a34a;">DÉBITO</th>
                <th style="padding:7px 6px;text-align:right;font-size:10px;font-weight:700;color:#dc2626;">CRÉDITO</th>
                <th></th>
              </tr></thead>
              <tbody>${filas}</tbody>
              <tfoot>
                <tr style="border-top:2px solid ${C.border};background:#f8fafc;">
                  <td colspan="2" style="padding:8px 6px;font-weight:800;font-size:11.5px;">TOTALES</td>
                  <td style="padding:8px 6px;text-align:right;font-weight:800;color:#16a34a;">${fmtCOP(totD)}</td>
                  <td style="padding:8px 6px;text-align:right;font-weight:800;color:#dc2626;">${fmtCOP(totC)}</td>
                  <td></td>
                </tr>
                ${Math.abs(diff) >= 1 ? `
                <tr style="background:#fee2e2;">
                  <td colspan="5" style="padding:7px 6px;font-size:10.5px;font-weight:700;color:#dc2626;text-align:center;">
                    ⚖️ Diferencia: ${fmtCOP(Math.abs(diff))} — Débitos deben igualar Créditos
                  </td>
                </tr>` : `
                <tr style="background:#d1fae5;">
                  <td colspan="5" style="padding:7px 6px;font-size:10.5px;font-weight:700;color:#065f46;text-align:center;">
                    ✅ Asiento cuadrado
                  </td>
                </tr>`}
              </tfoot>
            </table>
          </div>
          <button data-action="asiento-manual-add-linea" style="${btnStyle(null,'secondary')};margin-top:10px;">+ Agregar fila</button>
        </div>
        <div style="padding:16px 24px;border-top:1px solid ${C.border};display:flex;justify-content:flex-end;gap:10px;">
          <button data-action="asiento-manual-cancelar" style="${btnStyle(null,'secondary')}">Cancelar</button>
          <button data-action="asiento-manual-guardar" style="${btnStyle(C.amber)}">💾 Registrar asiento</button>
        </div>
      </div>
    </div>
  `;
}

export function renderIVATab() {
  const hoy = today();
  const anio = parseInt(hoy.slice(0, 4), 10);           // de la fecha de Colombia
  if (!state.ivaFiltros) {
    const mes = parseInt(hoy.slice(5, 7), 10);          // ídem: UTC ya puede ir un día (y un mes) adelante
    const bim = Math.ceil(mes / 2);
    state.ivaFiltros = {
      desde: `${anio}-${String((bim-1)*2+1).padStart(2,"0")}-01`,
      hasta: hoy
    };
  }
  const f = state.ivaFiltros;
  const desde = f.desde || `${anio}-01-01`;
  const hasta  = f.hasta  || hoy;

  // ── El Formulario 300 se arma desde el LIBRO, no desde los documentos ─────
  // Antes se sumaba el IVA de todas las OCP del período aunque no estuvieran
  // causadas (el IVA descontable nace con la factura del proveedor, no con la
  // orden), y el reteIVA restado era el practicado A proveedores (cuenta 2367,
  // que se declara en el Form. 350) en vez del que NOS practican los clientes
  // (cuenta 1366, que sí descuenta el 300). Leyendo los asientos, el reporte
  // dice exactamente lo mismo que la contabilidad — reversas y anulaciones
  // incluidas.
  const movsPeriodo = (cuenta) => {
    let deb = 0, cred = 0, n = 0;
    (state.data.asientos||[]).forEach(as => {
      if (desde && as.fecha < desde) return;
      if (hasta && as.fecha > hasta) return;
      (as.movimientos||[]).forEach(m => {
        if (m.cuenta !== cuenta) return;
        deb += parseNumber(m.debito)||0; cred += parseNumber(m.credito)||0; n++;
      });
    });
    return { deb, cred, n };
  };
  const m2408 = movsPeriodo("2408");   // IVA generado (créditos) y sus reversas (débitos: NC, anulaciones)
  const m1355 = movsPeriodo("1355");   // IVA descontable en compras causadas
  const m1366 = movsPeriodo("1366");   // ReteIVA que NOS practicaron los clientes (a favor)
  const ivaGenerado     = m2408.cred;
  const ivaNC           = m2408.deb;
  const ivaGeneradoNeto = ivaGenerado - ivaNC;
  const ivaDescontable  = m1355.deb - m1355.cred;
  const reteIVA         = m1366.deb - m1366.cred;
  const ivaNeto = ivaGeneradoNeto - ivaDescontable - reteIVA;

  // Detalle informativo por documento (las cifras oficiales son las del libro)
  const factsPeriodo = (state.data.facturas||[]).filter(fa => {
    if (fa.estado==="anulada"||fa.estado==="cancelada") return false;
    const fecha = fa.fecha||fa.fecha_emision||"";
    return (!desde||fecha>=desde) && (!hasta||fecha<=hasta);
  });
  const baseGravada  = factsPeriodo.reduce((s,fa)=>s+(parseNumber(fa.subtotal)||0),0);
  const ocpPeriodo = (state.data.ocp||[]).filter(o => {
    if (o.estado==="cancelada") return false;
    const fecha = o.fecha||"";
    return (!desde||fecha>=desde) && (!hasta||fecha<=hasta) && (parseNumber(o.iva)||0)>0;
  });
  const baseCompras    = ocpPeriodo.reduce((s,o)=>s+(parseNumber(o.subtotal)||0),0);
  const ncPeriodo = (state.data.notas_credito||[]).filter(nc => {
    if (nc.estado === "anulada") return false;
    const fecha = nc.fecha||"";
    return (!desde||fecha>=desde) && (!hasta||fecha<=hasta);
  });
  const saldoFavor = ivaNeto < 0;
  const red="#dc2626", green="#16a34a";
  const ivaColor = saldoFavor ? green : (ivaNeto>0 ? red : C.muted);
  const ivaLabel = saldoFavor ? "SALDO A FAVOR" : (ivaNeto>0 ? "IVA A PAGAR" : "PERÍODO EN CERO");

  // Selector bimestral
  const bimestres = [
    {l:"Ene-Feb",d:`${anio}-01-01`,h:`${anio}-02-28`},{l:"Mar-Abr",d:`${anio}-03-01`,h:`${anio}-04-30`},
    {l:"May-Jun",d:`${anio}-05-01`,h:`${anio}-06-30`},{l:"Jul-Ago",d:`${anio}-07-01`,h:`${anio}-08-31`},
    {l:"Sep-Oct",d:`${anio}-09-01`,h:`${anio}-10-31`},{l:"Nov-Dic",d:`${anio}-11-01`,h:`${anio}-12-31`},
  ];

  const filtros = `
    <div style="margin-bottom:10px;">
      <div style="display:flex;gap:6px;margin-bottom:8px;flex-wrap:wrap;align-items:center;">
        <span style="font-size:10px;font-weight:700;color:${C.muted};letter-spacing:.5px;">BIMESTRE ${anio}:</span>
        ${bimestres.map(b=>`
          <button data-action="iva-bimestre" data-desde="${b.d}" data-hasta="${b.h}"
            style="padding:4px 10px;border-radius:6px;border:1px solid ${(desde===b.d&&hasta===b.h)?C.amber:C.border};
              background:${(desde===b.d&&hasta===b.h)?C.amber+"20":"white"};font-size:10.5px;font-weight:600;cursor:pointer;
              color:${(desde===b.d&&hasta===b.h)?C.amber:C.text};">${b.l}</button>`).join("")}
      </div>
      <div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;">
        <div>
          <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Desde</label>
          <input type="date" value="${desde}" style="${inputStyle}width:150px;" onchange="state.ivaFiltros.desde=this.value;render();"/>
        </div>
        <div>
          <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Hasta</label>
          <input type="date" value="${hasta}" style="${inputStyle}width:150px;" onchange="state.ivaFiltros.hasta=this.value;render();"/>
        </div>
      </div>
    </div>
  `;

  const resumen = `
    <div style="background:white;border:2px solid ${ivaColor}30;border-radius:14px;padding:14px;margin-bottom:10px;">
      <div style="display:flex;gap:28px;align-items:flex-start;flex-wrap:wrap;">
        <div style="flex:1;min-width:180px;text-align:center;border-right:1px solid ${C.border};padding-right:28px;">
          <div style="font-size:10px;font-weight:700;color:${C.muted};letter-spacing:1px;margin-bottom:8px;">${ivaLabel}</div>
          <div style="font-size:38px;font-weight:900;color:${ivaColor};">${fmtCOP(Math.abs(ivaNeto))}</div>
          <div style="font-size:10.5px;color:${C.muted};margin-top:6px;">
            ${saldoFavor?"Saldo a favor — traslado al siguiente período":ivaNeto>0?"Formulario 300 — DIAN":""}
          </div>
        </div>
        <div style="flex:2;min-width:300px;">
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
            ${[
              {l:"IVA GENERADO (2408)",   v:ivaGenerado,      c:red,     n:`${factsPeriodo.length} fact. | base ${fmtCOP(baseGravada)}`},
              {l:"(−) NC / ANULACIONES",  v:ivaNC,            c:C.muted, n:`${ncPeriodo.length} notas crédito (reversas del libro)`},
              {l:"IVA GENERADO NETO",     v:ivaGeneradoNeto,  c:ivaGeneradoNeto>0?red:C.muted, n:"Base para Form. 300"},
              {l:"(−) IVA DESCONTABLE (1355)", v:ivaDescontable, c:green, n:`compras CAUSADAS | base doc. ${fmtCOP(baseCompras)}`},
              {l:"(−) RETEIVA QUE NOS PRACTICARON (1366)", v:reteIVA, c:green, n:"Retenida por clientes agentes de retención"},
              {l:ivaLabel,                v:Math.abs(ivaNeto),c:ivaColor,n:saldoFavor?"Saldo en tu favor":"A pagar a la DIAN"},
            ].map(row=>`
              <div style="background:#f8fafc;border-radius:6px;padding:11px 13px;">
                <div style="font-size:10px;font-weight:700;color:${C.muted};letter-spacing:.5px;margin-bottom:4px;">${row.l}</div>
                <div style="font-size:14px;font-weight:800;color:${row.c};">${fmtCOP(row.v)}</div>
                <div style="font-size:10px;color:${C.muted};margin-top:2px;">${row.n}</div>
              </div>`).join("")}
          </div>
        </div>
      </div>
    </div>
  `;

  const aviso = `
    <div style="background:#fffbeb;border:1px solid #fcd34d;border-radius:6px;padding:12px 16px;font-size:11.5px;color:#92400e;margin-bottom:10px;line-height:1.6;">
      <strong>📋 Formulario 300 — Declaración de IVA en Colombia</strong><br/>
      Régimen ordinario: declaración <strong>bimestral</strong>. Pymes con ingresos ≤ 92.000 UVT el año anterior: <strong>cuatrimestral</strong>.
      Tarifa general: 19% | Bienes/servicios especiales: 5% | Excluidos/exentos: 0%.<br/>
      <span style="font-size:10.5px;color:#a16207;">Este resumen es un insumo de gestión. Verifica con tu contador antes de presentar.</span>
    </div>
  `;

  const tablaVentas = factsPeriodo.filter(fa=>(parseNumber(fa.iva)||0)>0).length===0 ? "" : `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:18px 20px;margin-bottom:9px;">
      <h3 style="margin:0 0 10px;font-size:14px;font-weight:700;">🧾 Facturas con IVA en el período</h3>
      <div style="overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
          <thead><tr style="background:#f1f5f9;">
            <th style="padding:6px 10px;text-align:left;">Fecha</th>
            <th style="padding:6px 10px;text-align:left;">N°</th>
            <th style="padding:6px 10px;text-align:left;">Cliente</th>
            <th style="padding:6px 10px;text-align:right;">Base</th>
            <th style="padding:6px 10px;text-align:right;color:${red};">IVA</th>
          </tr></thead>
          <tbody>
            ${factsPeriodo.filter(fa=>(parseNumber(fa.iva)||0)>0).slice(0,40).map(fa=>{
              const cli=(state.data.clientes||[]).find(c=>c.id===fa.cliente_id)||{};
              return `<tr style="border-top:1px solid ${C.border}30;">
                <td style="padding:5px 10px;color:${C.muted};">${fa.fecha||""}</td>
                <td style="padding:5px 10px;font-weight:700;">${escapeHTML(fa.numero||fa.id||"")}</td>
                <td style="padding:5px 10px;">${escapeHTML(cli.nombre||"—")}</td>
                <td style="padding:5px 10px;text-align:right;">${fmtCOP(parseNumber(fa.subtotal)||0)}</td>
                <td style="padding:5px 10px;text-align:right;font-weight:700;color:${red};">${fmtCOP(parseNumber(fa.iva)||0)}</td>
              </tr>`;
            }).join("")}
          </tbody>
        </table>
      </div>
    </div>
  `;

  const tablaCompras = ocpPeriodo.length===0 ? "" : `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:18px 20px;margin-bottom:9px;">
      <h3 style="margin:0 0 10px;font-size:14px;font-weight:700;">📦 IVA descontable (OCPs)</h3>
      <div style="overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
          <thead><tr style="background:#f1f5f9;">
            <th style="padding:6px 10px;text-align:left;">Fecha</th>
            <th style="padding:6px 10px;text-align:left;">OCP</th>
            <th style="padding:6px 10px;text-align:left;">Proveedor</th>
            <th style="padding:6px 10px;text-align:right;">Base</th>
            <th style="padding:6px 10px;text-align:right;color:${green};">IVA Desc.</th>
          </tr></thead>
          <tbody>
            ${ocpPeriodo.slice(0,40).map(o=>{
              const prov=(state.data.proveedores||[]).find(p=>p.id===o.proveedor_id)||{};
              return `<tr style="border-top:1px solid ${C.border}30;">
                <td style="padding:5px 10px;color:${C.muted};">${o.fecha||""}</td>
                <td style="padding:5px 10px;font-weight:700;">${escapeHTML(o.numero||o.id||"")}</td>
                <td style="padding:5px 10px;">${escapeHTML(prov.nombre||"—")}</td>
                <td style="padding:5px 10px;text-align:right;">${fmtCOP(parseNumber(o.subtotal)||0)}</td>
                <td style="padding:5px 10px;text-align:right;font-weight:700;color:${green};">${fmtCOP(parseNumber(o.iva)||0)}</td>
              </tr>`;
            }).join("")}
          </tbody>
        </table>
      </div>
    </div>
  `;


  // ── ICA sobre ventas ─────────────────────────────────────────────
  // La tarifa y el municipio viven en Parámetros Fiscales (los certifica el RIT).
  // Antes vivían solo en memoria de esta pantalla, con 4,14 ‰ de arranque: cada
  // recarga borraba lo ajustado y la provisión salía con una tarifa inventada.
  const _pfIca = getParametrosFiscales();
  const icaCfg = { tarifa: parsePct(_pfIca.ica_tarifa_mil) || 0, municipio: _pfIca.ica_municipio || "" };
  const icaTarifa = icaCfg.tarifa;  // en ‰ (por mil)
  const icaCausado = baseGravada * icaTarifa / 1000;

  const icaSection = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:18px 20px;margin-bottom:9px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;flex-wrap:wrap;gap:10px;">
        <h3 style="margin:0;font-size:14px;font-weight:700;">🏙️ ICA — Industria y Comercio</h3>
        <div style="display:flex;gap:10px;align-items:flex-end;flex-wrap:wrap;">
          <div>
            <label style="font-size:10px;font-weight:700;color:${C.muted};display:block;margin-bottom:3px;">MUNICIPIO</label>
            <input value="${escapeHTML(icaCfg.municipio||"")}" style="${inputStyle}width:130px;" placeholder="Bogotá D.C."
              onchange="const pf=getParametrosFiscales();pf.ica_municipio=this.value;saveParametrosFiscales(pf);render();"/>
          </div>
          <div>
            <label style="font-size:10px;font-weight:700;color:${C.muted};display:block;margin-bottom:3px;">TARIFA (‰ por mil)</label>
            <input type="number" step="0.001" min="0" max="20" value="${icaTarifa}"
              style="${inputStyle}width:90px;text-align:center;font-weight:700;"
              onchange="const pf=getParametrosFiscales();pf.ica_tarifa_mil=parseFloat(this.value)||0;saveParametrosFiscales(pf);render();"/>
          </div>
        </div>
      </div>
      ${icaTarifa > 0 ? "" : `
        <div style="background:#fffbeb;border:1px solid #fcd34d;border-radius:6px;padding:7px 10px;font-size:10.5px;color:#78350f;margin-bottom:9px;">
          ⚠️ Sin tarifa de ICA configurada: el impuesto sale en cero. La tarifa de tu actividad la certifica el RIT del municipio — escríbela aquí o en Parámetros Fiscales.
        </div>`}
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;">
        <div style="background:#f8fafc;border-radius:6px;padding:9px;">
          <div style="font-size:10px;font-weight:700;color:${C.muted};margin-bottom:4px;">BASE GRAVABLE (VENTAS)</div>
          <div style="font-size:12px;font-weight:800;color:${C.text};">${fmtCOP(baseGravada)}</div>
        </div>
        <div style="background:#f8fafc;border-radius:6px;padding:9px;">
          <div style="font-size:10px;font-weight:700;color:${C.muted};margin-bottom:4px;">TARIFA ${icaTarifa}‰</div>
          <div style="font-size:12px;font-weight:800;color:#4C5FA8;">${icaTarifa}‰ sobre base</div>
        </div>
        <div style="background:#e8ecf6;border-radius:6px;padding:9px;">
          <div style="font-size:10px;font-weight:700;color:#12264D;margin-bottom:4px;">ICA CAUSADO</div>
          <div style="font-size:12px;font-weight:800;color:#4C5FA8;">${fmtCOP(icaCausado)}</div>
        </div>
      </div>
      <div style="margin-top:10px;font-size:10.5px;color:${C.muted};">
        Bogotá: 4.14‰ actividades comerciales | Medellín: 5‰ | Cali: 5‰ | Varía por actividad económica y municipio.
        El ICA se declara mensual o bimestral según el municipio. Asiento: Db 5150 / Cr 2380.
      </div>
    </div>
  `;

  // ── Card visual Provisión recomendada ─────────────────────────────
  const totalProvisionar = (ivaNeto > 0 ? ivaNeto : 0) + icaCausado;
  const provisionCard = `
    <div style="background:#f8fafc;border:2px solid #f59e0b;border-radius:14px;padding:20px 24px;margin-bottom:9px;">
      <div style="font-size:12px;font-weight:800;color:#78350f;margin-bottom:9px;">💰 Provisión recomendada — aparta en cuenta separada</div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:9px;margin-bottom:12px;">
        <div style="background:white;border-radius:6px;padding:9px;text-align:center;">
          <div style="font-size:10px;font-weight:700;color:#92400e;margin-bottom:4px;">IVA NETO A PAGAR</div>
          <div style="font-size:16px;font-weight:900;color:${ivaNeto>0?"#dc2626":"#16a34a"};">${fmtCOP(Math.max(0,ivaNeto))}</div>
          <div style="font-size:10px;color:#a16207;">${ivaNeto>0?"A pagar DIAN":"Saldo a favor"}</div>
        </div>
        <div style="background:white;border-radius:6px;padding:9px;text-align:center;">
          <div style="font-size:10px;font-weight:700;color:#92400e;margin-bottom:4px;">ICA CAUSADO</div>
          <div style="font-size:16px;font-weight:900;color:#4C5FA8;">${fmtCOP(icaCausado)}</div>
          <div style="font-size:10px;color:#a16207;">${icaTarifa}‰ sobre ${fmtCOP(baseGravada)}</div>
        </div>
        <div style="background:#78350f;border-radius:6px;padding:9px;text-align:center;">
          <div style="font-size:10px;font-weight:700;color:#fde68a;margin-bottom:4px;">TOTAL A PROVISIONAR</div>
          <div style="font-size:16px;font-weight:900;color:white;">${fmtCOP(totalProvisionar)}</div>
          <div style="font-size:10px;color:#fde68a;">IVA + ICA del período</div>
        </div>
      </div>
      <div style="font-size:10.5px;color:#78350f;line-height:1.6;">
        ✅ Recomendación: mantén <strong>${fmtCOP(totalProvisionar)}</strong> apartados en una cuenta bancaria auxiliar
        para cubrir las obligaciones fiscales de este período (IVA Formulario 300 + ICA municipio ${escapeHTML(icaCfg.municipio||"")}).
      </div>
    </div>
  `;

  return filtros + provisionCard + resumen + aviso + icaSection + tablaVentas + tablaCompras;
}

export function getDatos1001(anio) {
  const desde = `${anio}-01-01`, hasta = `${anio}-12-31`;
  const grouped = {};

  const _ensureId = (id) => {
    if (!grouped[id]) grouped[id] = {
      prov: (state.data.proveedores||[]).find(p => p.id === id) || {},
      subtotal: 0, iva: 0, retefuente: 0, reteiva: 0, reteica: 0
    };
  };

  // Recorrer asientos de compra en el período
  (state.data.asientos||[]).forEach(a => {
    if (!a.origen || a.origen.tipo !== "OCP") return;
    if (a.fecha < desde || a.fecha > hasta) return;
    const ocp = (state.data.ocp||[]).find(o => o.id === a.origen.id);
    if (!ocp) return;
    const id = ocp.proveedor_id || "sin_id";
    _ensureId(id);
    (a.movimientos||[]).forEach(m => {
      // Base de compras: inventario adquirido (1435)
      if (m.cuenta === "1435" && m.debito > 0) grouped[id].subtotal += m.debito;
      // IVA descontable (1355) — se reporta como IVA pagado en compras
      if (m.cuenta === "1355" && m.debito > 0) grouped[id].iva      += m.debito;
      // Retenciones practicadas al proveedor
      if (m.cuenta === "2365" && m.credito > 0) grouped[id].retefuente += m.credito;
      if (m.cuenta === "2367" && m.credito > 0) grouped[id].reteiva    += m.credito;
      if (m.cuenta === "2368" && m.credito > 0) grouped[id].reteica    += m.credito;
    });
  });

  // ── Costos asociados pagados por CUENTA DE COBRO ────────────────────────
  // Antes esta función solo recorría asientos con origen OCP, así que todo lo
  // pagado a personas naturales por cuentas de cobro quedaba FUERA del 1001 —
  // justo los pagos que la DIAN más quiere ver identificados por beneficiario.
  // La CxP directa guarda su tercero y su retención, así que se lee de ahí y no
  // del asiento: es la fuente que tiene el bruto, lo retenido y la ficha.
  (state.data.cuentas_pagar || []).forEach(x => {
    const fecha = x.fecha || "";
    if (fecha < desde || fecha > hasta) return;
    if (!x._asientoId) return;                 // sin causar no hay pago que reportar
    const id = x.tercero_id || "sin_id";
    _ensureId(id);
    grouped[id].subtotal   += parseNumber(x.valor) || 0;
    grouped[id].retefuente += parseNumber(x.retefuente) || 0;
    grouped[id].reteica    += parseNumber(x.reteica) || 0;
    // El concepto 5004 "Servicios" es el que les corresponde; queda sugerido
    // para que la contadora lo confirme o lo cambie como en cualquier otra fila.
    if (!grouped[id]._conceptoSugerido) grouped[id]._conceptoSugerido = "5004";
  });

  return Object.values(grouped)
    .filter(r => r.subtotal > 0 || r.retefuente > 0 || r.reteiva > 0 || r.reteica > 0)
    .map(r => ({ ...r, concepto_codigo: r.prov.concepto_codigo || r._conceptoSugerido || "" }));
}

export function getDatos1007(anio) {
  const desde = `${anio}-01-01`, hasta = `${anio}-12-31`;
  const grouped = {};
  (state.data.facturas||[]).forEach(f => {
    if (!f._asientoVenta || f.estado === "anulada") return;
    if (f.fecha < desde || f.fecha > hasta) return;
    const id = f.cliente_id || "sin_id";
    if (!grouped[id]) grouped[id] = { cliente: (state.data.clientes||[]).find(c=>c.id===id) || {}, ingresos:0, devoluciones:0 };
    grouped[id].ingresos += parseNumber(f.subtotal) || 0;
  });
  (state.data.notas_credito||[]).forEach(nc => {
    if (!nc._asientoNC) return;
    if (nc.fecha < desde || nc.fecha > hasta) return;
    const id = nc.cliente_id || "sin_id";
    if (!grouped[id]) grouped[id] = { cliente: (state.data.clientes||[]).find(c=>c.id===id) || {}, ingresos:0, devoluciones:0 };
    grouped[id].devoluciones += parseNumber(nc.subtotal) || 0;
  });
  return Object.values(grouped);
}

export function getDatos1008(hasta) {
  const grouped = {};
  (state.data.ocp||[]).forEach(ocp => {
    if (ocp.estado === "cancelada") return;
    if (ocp.fecha > hasta) return;
    const saldo = getSaldoOCP(ocp);
    if (saldo <= 0) return;
    const id = ocp.proveedor_id || "sin_id";
    if (!grouped[id]) grouped[id] = { prov: (state.data.proveedores||[]).find(p=>p.id===id) || {}, saldo:0 };
    grouped[id].saldo += saldo;
  });
  return Object.values(grouped);
}

export function getDatos1009(hasta) {
  const grouped = {};
  (state.data.facturas||[]).forEach(f => {
    // "anulada" es el estado real de FACT (no "cancelada"); los borradores no son CxC
    if (f.estado === "anulada" || f.estado === "borrador" || f.estado === "pagada") return;
    if (f.fecha > hasta) return;
    const saldo = getSaldoFactura(f); // neto de abonos parciales y notas crédito
    if (saldo <= 0) return;
    const id = f.cliente_id || "sin_id";
    if (!grouped[id]) grouped[id] = { cliente: (state.data.clientes||[]).find(c=>c.id===id) || {}, saldo:0 };
    grouped[id].saldo += saldo;
  });
  return Object.values(grouped);
}

export function renderExogenaTab() {
  if (!state.exogenaFormato) state.exogenaFormato = "1001";
  if (!state.exogenaAnio) state.exogenaAnio = parseInt(today().slice(0, 4), 10);
  const formato = state.exogenaFormato;
  const anio = state.exogenaAnio;
  const hasta = `${anio}-12-31`;

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Formato</label>
        <select style="${inputStyle}width:380px;cursor:pointer;" onchange="state.exogenaFormato=this.value;render();">
          ${Object.entries(EXOGENA_FORMATOS).map(([k,v]) => `<option value="${k}" ${formato===k?"selected":""}>${v.label}</option>`).join("")}
        </select>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Año / Vigencia</label>
        <input type="number" value="${anio}" style="${inputStyle}width:100px;text-align:right;" onchange="state.exogenaAnio=parseInt(this.value)||new Date().getFullYear();render();"/>
      </div>
      <button data-action="export-exogena-csv" style="${btnStyle("#0E7490")}">⬇️ Descargar CSV</button>
    </div>
    <div style="font-size:10.5px;color:${C.muted};margin-bottom:9px;background:#fffbeb;border:1px solid #fcd34d;border-radius:6px;padding:10px;">
      ⚠️ Este archivo es un insumo preliminar generado desde los registros del sistema. Antes de presentarlo en el Prevalidador Exógena de la DIAN debes: completar/validar los códigos DANE de país, departamento y municipio, el código de concepto (formato 1001) y verificar los topes mínimos de información exigidos para la vigencia ${anio}.
    </div>
    ${formato === "1001" ? `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:16px 18px;margin-bottom:9px;">
      <div style="font-size:12px;font-weight:700;margin-bottom:10px;">🏷️ Código de concepto por proveedor (Formato 1001)</div>
      <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(320px,1fr));gap:10px;">
        ${getDatos1001(anio).map(r => `
          <div style="padding:6px 10px;border:1px solid ${C.border};border-radius:6px;display:flex;gap:8px;align-items:center;">
            <div style="flex:1;min-width:0;">
              <div style="font-weight:700;font-size:11.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHTML(r.prov.nombre||"Sin nombre")}</div>
              <div style="font-size:10px;color:${C.muted};">NIT: ${escapeHTML(r.prov.nit||"—")}</div>
            </div>
            <select data-action="save-concepto-proveedor" data-prov-id="${r.prov.id||""}" style="${inputStyle}min-width:220px;font-size:10.5px;">
              <option value="">— Seleccionar concepto —</option>
              ${Object.entries(CONCEPTOS_1001).map(([k,v]) => `<option value="${k}" ${r.prov.concepto_codigo===k?"selected":""}>${k} — ${escapeHTML(v)}</option>`).join("")}
            </select>
          </div>
        `).join("")}
      </div>
    </div>
    ` : ""}
  `;

  let head = [], rows = [];
  if (formato === "1001") {
    head = ["Concepto DIAN","Tipo Doc","Identificación","DV","Razón Social / Nombre","Subtotal pagos/abonos","ReteFuente","ReteIVA","ReteICA"];
    rows = getDatos1001(anio).map(r => [
      r.concepto_codigo ? `${r.concepto_codigo} — ${CONCEPTOS_1001[r.concepto_codigo]||""}` : "⚠️ Sin concepto",
      r.prov.tipo_documento||"NIT", r.prov.nit||"", r.prov.dv||"",
      r.prov.nombre||"Sin identificar", r.subtotal, r.retefuente, r.reteiva, r.reteica
    ]);
  } else if (formato === "1007") {
    head = ["Tipo Doc","Identificación","DV","Razón Social / Nombre","Ingresos brutos","Devoluciones","Ingresos netos"];
    rows = getDatos1007(anio).map(r => [r.cliente.tipo_documento||"NIT", r.cliente.nit||"", r.cliente.dv||"", r.cliente.nombre||"Sin identificar", r.ingresos, r.devoluciones, r.ingresos - r.devoluciones]);
  } else if (formato === "1008") {
    head = ["Tipo Doc","Identificación","DV","Razón Social / Nombre","Saldo a 31/12"];
    rows = getDatos1008(hasta).map(r => [r.prov.tipo_documento||"NIT", r.prov.nit||"", r.prov.dv||"", r.prov.nombre||"Sin identificar", r.saldo]);
  } else {
    head = ["Tipo Doc","Identificación","DV","Razón Social / Nombre","Saldo a 31/12"];
    rows = getDatos1009(hasta).map(r => [r.cliente.tipo_documento||"NIT", r.cliente.nit||"", r.cliente.dv||"", r.cliente.nombre||"Sin identificar", r.saldo]);
  }

  if (rows.length === 0) {
    return filtersHTML + `<div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">Sin datos para este formato y período.</div>`;
  }

  const totales = head.map((h,i) => i < 4 ? null : rows.reduce((s,r)=>s+(parseNumber(r[i])||0),0));

  return filtersHTML + `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          ${head.map(h => `<th style="padding:6px 10px;text-align:${typeof h==="string" && (h.includes("Saldo")||h.includes("Ingres")||h.includes("Rete")||h.includes("Subtotal")||h.includes("pagos"))?"right":"left"};font-size:10.5px;font-weight:700;color:${C.text};">${h}</th>`).join("")}
        </tr></thead>
        <tbody>
          ${rows.map(r => `
            <tr style="border-top:1px solid ${C.border};">
              ${r.map((v,i) => `<td style="padding:6px 10px;${i>=4?"text-align:right;":""}${i===3?"font-weight:700;":""}">${i>=4 ? fmtCOP(v) : escapeHTML(String(v))}</td>`).join("")}
            </tr>
          `).join("")}
        </tbody>
        <tfoot>
          <tr style="border-top:2px solid ${C.border};font-weight:800;background:#f9fafb;">
            ${head.map((h,i) => i < 4 ? (i===0?`<td style="padding:6px 10px;" colspan="4">TOTALES (${rows.length} terceros)</td>`:"") : `<td style="padding:6px 10px;text-align:right;">${fmtCOP(totales[i])}</td>`).join("")}
          </tr>
        </tfoot>
      </table>
    </div>
  `;
}

export function exportExogenaCSV() {
  const formato = state.exogenaFormato || "1001";
  const anio = state.exogenaAnio || parseInt(today().slice(0, 4), 10);
  const hasta = `${anio}-12-31`;

  let head = [], rows = [];
  if (formato === "1001") {
    head = ["Codigo Concepto","Tipo Doc","Identificacion","DV","Razon Social","Subtotal pagos abonos","ReteFuente","ReteIVA","ReteICA"];
    rows = getDatos1001(anio).map(r => [r.concepto_codigo||"", r.prov.tipo_documento||"NIT", r.prov.nit||"", r.prov.dv||"", r.prov.nombre||"Sin identificar", r.subtotal, r.retefuente, r.reteiva, r.reteica]);
  } else if (formato === "1007") {
    head = ["Tipo Doc","Identificacion","DV","Razon Social","Ingresos brutos","Devoluciones","Ingresos netos"];
    rows = getDatos1007(anio).map(r => [r.cliente.tipo_documento||"NIT", r.cliente.nit||"", r.cliente.dv||"", r.cliente.nombre||"Sin identificar", r.ingresos, r.devoluciones, r.ingresos - r.devoluciones]);
  } else if (formato === "1008") {
    head = ["Tipo Doc","Identificacion","DV","Razon Social","Saldo 31 dic"];
    rows = getDatos1008(hasta).map(r => [r.prov.tipo_documento||"NIT", r.prov.nit||"", r.prov.dv||"", r.prov.nombre||"Sin identificar", r.saldo]);
  } else {
    head = ["Tipo Doc","Identificacion","DV","Razon Social","Saldo 31 dic"];
    rows = getDatos1009(hasta).map(r => [r.cliente.tipo_documento||"NIT", r.cliente.nit||"", r.cliente.dv||"", r.cliente.nombre||"Sin identificar", r.saldo]);
  }

  const csvEscape = v => {
    const s = String(v ?? "");
    return /[",;\n]/.test(s) ? `"${s.replace(/"/g,'""')}"` : s;
  };
  const lines = [head.map(csvEscape).join(";")].concat(rows.map(r => r.map(csvEscape).join(";")));
  const csv = "\uFEFF" + lines.join("\r\n");
  const blob = new Blob([csv], { type:"text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Exogena_Formato_${formato}_${anio}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function renderLibroDiarioTab() {
  if (!state.contabFiltros) state.contabFiltros = { desde:"", hasta:"" };
  const f = state.contabFiltros;
  let asientos = [...(state.data.asientos||[])];
  if (f.desde) asientos = asientos.filter(a => a.fecha >= f.desde);
  if (f.hasta) asientos = asientos.filter(a => a.fecha <= f.hasta);
  asientos.sort((a,b) => (a.fecha+a.numero).localeCompare(b.fecha+b.numero) * -1);

  const totalGeneral = asientos.reduce((s,a)=>s+(parseNumber(a.totalDebito)||0),0);

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Desde</label>
        <input type="date" value="${f.desde}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.desde=this.value;render();"/>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Hasta</label>
        <input type="date" value="${f.hasta}" style="${inputStyle}width:150px;" onchange="state.contabFiltros.hasta=this.value;render();"/>
      </div>
      <button data-action="nuevo-asiento-manual" style="${btnStyle('#0E7490')}">✏️ Nuevo asiento manual</button>
      <div style="margin-left:auto;text-align:right;">
        <div style="font-size:10px;color:${C.muted};font-weight:700;">TOTAL ASIENTOS</div>
        <div style="font-size:16px;font-weight:800;color:#0E7490;">${asientos.length} · ${fmtCOP(totalGeneral)}</div>
      </div>
    </div>
  `;

  if (asientos.length === 0) {
    return filtersHTML + `
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">
        <div style="font-size:40px;margin-bottom:10px;">📒</div>
        Sin asientos contables. Se generan automáticamente al causar facturas, notas crédito, compras (OCP) y pagos.
      </div>
    `;
  }

  const asientosHTML = asientos.map(a => `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;margin-bottom:10px;overflow:hidden;">
      <div style="padding:7px 10px;background:#f8fafc;border-bottom:1px solid ${C.border};display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px;">
        <div>
          <strong style="color:#0E7490;">${escapeHTML(a.numero)}</strong>
          <span style="color:${C.muted};font-size:11.5px;margin-left:8px;">${fmtDate(a.fecha)}</span>
          <span style="color:${C.text};font-size:11.5px;margin-left:8px;">${escapeHTML(a.concepto)}</span>
          ${a.fecha_documento ? `<span title="El documento es de una fecha cuyo mes ya estaba cerrado, así que se registró en el periodo abierto" style="background:#fffbeb;border:1px solid #fcd34d;color:#92400e;font-size:9.5px;font-weight:700;border-radius:5px;padding:1px 6px;margin-left:8px;white-space:nowrap;">📅 Documento del ${fmtDate(a.fecha_documento)}</span>` : ""}
          ${a.origen ? `<span data-action="ir-a-documento" data-tipo="${a.origen.tipo}" data-id="${a.origen.id}" style="color:${DOC_INFO[a.origen.tipo]?DOC_INFO[a.origen.tipo].color:C.purple};font-weight:700;cursor:pointer;text-decoration:underline;font-size:10.5px;margin-left:8px;">[Ver ${escapeHTML(a.origen.numero)}]</span>` : ""}
        </div>
        ${!a.balanceado ? `<span style="background:#fee2e2;color:#dc2626;padding:2px 8px;border-radius:6px;font-size:10px;font-weight:700;">⚠️ Descuadrado</span>` : ""}
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
        <thead><tr style="background:#f9fafb;">
          <th style="padding:6px 10px;text-align:left;font-size:10px;color:${C.muted};">Código</th>
          <th style="padding:6px 10px;text-align:left;font-size:10px;color:${C.muted};">Cuenta</th>
          <th style="padding:6px 10px;text-align:right;font-size:10px;color:${C.muted};">Débito</th>
          <th style="padding:6px 10px;text-align:right;font-size:10px;color:${C.muted};">Crédito</th>
        </tr></thead>
        <tbody>
          ${a.movimientos.map(m => `
            <tr style="border-top:1px solid ${C.border};">
              <td style="padding:6px 10px;">${escapeHTML(m.cuenta)}</td>
              <td style="padding:6px 10px;">${escapeHTML(m.nombre)}</td>
              <td style="padding:6px 10px;text-align:right;">${m.debito ? fmtCOP(m.debito) : ""}</td>
              <td style="padding:6px 10px;text-align:right;">${m.credito ? fmtCOP(m.credito) : ""}</td>
            </tr>
          `).join("")}
          <tr style="border-top:2px solid ${C.border};font-weight:700;">
            <td colspan="2" style="padding:6px 10px;">TOTALES</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(a.totalDebito)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(a.totalCredito)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `).join("");

  return filtersHTML + asientosHTML;
}

export function renderLibroMayorTab() {
  const puc = [...(state.data.puc||[])].sort((a,b) => a.codigo.localeCompare(b.codigo));
  if (!state.contabCuenta && puc.length > 0) state.contabCuenta = puc[0].codigo;
  const cuentaSel = state.contabCuenta;
  const cuenta = puc.find(c => c.codigo === cuentaSel);

  const selectorHTML = `
    <div style="margin-bottom:9px;">
      <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Cuenta</label>
      <select style="${inputStyle}width:380px;cursor:pointer;" onchange="state.contabCuenta=this.value;render();">
        ${puc.map(c => `<option value="${c.codigo}" ${cuentaSel===c.codigo?"selected":""}>${escapeHTML(c.codigo)} - ${escapeHTML(c.nombre)}</option>`).join("")}
      </select>
    </div>
  `;

  if (!cuenta) return selectorHTML + `<div style="color:${C.muted};font-size:11.5px;">No hay cuentas en el PUC.</div>`;

  // Recolectar movimientos de todos los asientos para esta cuenta, ordenados por fecha
  let movimientos = [];
  (state.data.asientos||[]).forEach(a => {
    (a.movimientos||[]).forEach(m => {
      if (m.cuenta === cuentaSel) {
        movimientos.push({ fecha:a.fecha, numero:a.numero, concepto:a.concepto, origen:a.origen, debito:m.debito, credito:m.credito });
      }
    });
  });
  movimientos.sort((a,b) => (a.fecha+a.numero).localeCompare(b.fecha+b.numero));

  let saldo = 0;
  const filas = movimientos.map(m => {
    saldo += cuenta.naturaleza === "D" ? (m.debito - m.credito) : (m.credito - m.debito);
    return { ...m, saldo };
  });

  const totalDebito = movimientos.reduce((s,m)=>s+m.debito,0);
  const totalCredito = movimientos.reduce((s,m)=>s+m.credito,0);

  if (filas.length === 0) {
    return selectorHTML + `
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">
        <div style="font-size:40px;margin-bottom:10px;">📚</div>
        Sin movimientos registrados para esta cuenta.
      </div>
    `;
  }

  return selectorHTML + `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;margin-bottom:12px;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Fecha</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Asiento</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Concepto</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Débito</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Crédito</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Saldo</th>
        </tr></thead>
        <tbody>
          ${filas.map(m => `
            <tr style="border-top:1px solid ${C.border};">
              <td style="padding:6px 10px;color:${C.muted};">${fmtDate(m.fecha)}</td>
              <td style="padding:6px 10px;">${escapeHTML(m.numero)}</td>
              <td style="padding:6px 10px;">${escapeHTML(m.concepto)}</td>
              <td style="padding:6px 10px;text-align:right;">${m.debito ? fmtCOP(m.debito) : ""}</td>
              <td style="padding:6px 10px;text-align:right;">${m.credito ? fmtCOP(m.credito) : ""}</td>
              <td style="padding:6px 10px;text-align:right;font-weight:700;">${fmtCOP(m.saldo)}</td>
            </tr>
          `).join("")}
        </tbody>
        <tfoot>
          <tr style="border-top:2px solid ${C.border};font-weight:800;background:#f9fafb;">
            <td colspan="3" style="padding:6px 10px;">TOTALES / SALDO FINAL (${cuenta.naturaleza === "D" ? "Naturaleza Débito" : "Naturaleza Crédito"})</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totalDebito)}</td>
            <td style="padding:6px 10px;text-align:right;">${fmtCOP(totalCredito)}</td>
            <td style="padding:6px 10px;text-align:right;color:#0E7490;">${fmtCOP(saldo)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  `;
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "contab-tab": (d, el, e) => {{
      state.contabTab = d.tab;
      render();
      return;
    }},
  "generar-provision-renta": (d, el, e) => {{
      const valorProv = parseNumber(d.valor) || 0;
      if (valorProv <= 0) { alert("Sin utilidad — no se genera asiento."); return; }
      if (fechaEstaCerrada(d.hasta || today())) {
        alert(`⚠️ No se puede registrar: el periodo contable hasta ${fmtDate(fechaCierreVigente())} ya está cerrado.`);
        return;
      }
      if (!confirm(`¿Registrar asiento de provisión por ${fmtCOP(valorProv)}?\nDébito 5405 / Crédito 2615`)) return;
      const idxP = (state.data.asientos||[]).filter(a=>a.id.startsWith("PROV-RENTA-")).length + 1;
      const asientoRenta = {
        id: "PROV-RENTA-" + Date.now(),
        fecha: d.hasta || today(),
        numero: "PROV-RENTA-" + String(idxP).padStart(3,"0"),
        concepto: "Provisión impuesto de renta período " + (d.desde||"") + " / " + (d.hasta||""),
        tipo: "provision_renta",
        origen: { tipo: "provision_renta", id: null },
        movimientos: [
          { cuenta:"5405", descripcion:"Gasto impuesto de renta y complementarios", debito: valorProv, credito:0 },
          { cuenta:"2615", descripcion:"Provisión impuesto a las ganancias por pagar", debito:0, credito: valorProv }
        ],
        totalDebito: valorProv,
        totalCredito: valorProv,
        balanceado: true
      };
      if (!state.data.asientos) state.data.asientos = [];
      state.data.asientos.push(asientoRenta);
      saveData("asientos", state.data.asientos);
      alert(`✅ Asiento ${asientoRenta.numero} registrado en el Libro Diario.`);
      render();
      return;
    }},
  "iva-bimestre": (d, el, e) => {{
      if (!state.ivaFiltros) state.ivaFiltros = {};
      state.ivaFiltros.desde = d.desde || "";
      state.ivaFiltros.hasta = d.hasta || "";
      render();
      return;
    }},
  "nuevo-asiento-manual": (d, el, e) => {{
      state._asientoManualDraft = { fecha: today(), concepto: "",
        movimientos: [
          { cuenta:"", descripcion:"", debito:0, credito:0 },
          { cuenta:"", descripcion:"", debito:0, credito:0 },
          { cuenta:"", descripcion:"", debito:0, credito:0 }
        ]
      };
      state.modal = null;
      render();
      return;
    }},
  "asiento-manual-add-linea": (d, el, e) => {{
      if (state._asientoManualDraft) {
        state._asientoManualDraft.movimientos.push({ cuenta:"", descripcion:"", debito:0, credito:0 });
        render();
      }
      return;
    }},
  "asiento-manual-del-linea": (d, el, e) => {{
      const draftD = state._asientoManualDraft;
      if (draftD && draftD.movimientos.length > 2) {
        draftD.movimientos.splice(parseInt(d.idx)||0, 1);
        render();
      }
      return;
    }},
  "asiento-manual-cancelar": (d, el, e) => {{
      state._asientoManualDraft = null;
      render();
      return;
    }},
  "asiento-manual-guardar": async (d, el, e) => {{
      const draftG = state._asientoManualDraft;
      if (!draftG) return;
      const totD = draftG.movimientos.reduce((s,m)=>s+(parseNumber(m.debito)||0),0);
      const totC = draftG.movimientos.reduce((s,m)=>s+(parseNumber(m.credito)||0),0);
      if (Math.abs(totD-totC) > 1) {
        alert(`⚖️ El asiento no cuadra.\nDébitos: ${fmtCOP(totD)}\nCréditos: ${fmtCOP(totC)}\nDiferencia: ${fmtCOP(Math.abs(totD-totC))}`);
        return;
      }
      if (!draftG.fecha) { alert("Ingresa la fecha del asiento."); return; }
      if (fechaEstaCerrada(draftG.fecha)) {
        alert(`⚠️ No se puede registrar: el periodo contable hasta ${fmtDate(fechaCierreVigente())} ya está cerrado.`);
        return;
      }
      const lineas = draftG.movimientos.filter(m=>m.cuenta);
      if (!lineas.length) { alert("Agrega al menos una cuenta PUC."); return; }
      let numeroMan;
      try {
        numeroMan = await siguienteNumeroDoc("MAN");
      } catch (err) {
        alert("⚠️ " + err.message);
        return;
      }
      const nuevoAsiento = {
        id: "MAN-" + Date.now(),
        fecha: draftG.fecha,
        numero: numeroMan,
        concepto: draftG.concepto || "Asiento manual",
        tipo: "manual",
        origen: { tipo: "manual", id: null },
        movimientos: lineas.map(m => ({
          cuenta: m.cuenta.trim(),
          descripcion: (m.descripcion||draftG.concepto||"").trim(),
          debito: parseNumber(m.debito)||0,
          credito: parseNumber(m.credito)||0
        }))
      };
      // Totales/balanceado: sin estos campos el Libro Diario sumaba NaN
      nuevoAsiento.totalDebito = nuevoAsiento.movimientos.reduce((sm,m)=>sm+m.debito,0);
      nuevoAsiento.totalCredito = nuevoAsiento.movimientos.reduce((sm,m)=>sm+m.credito,0);
      nuevoAsiento.balanceado = Math.abs(nuevoAsiento.totalDebito - nuevoAsiento.totalCredito) < 1;
      if (!state.data.asientos) state.data.asientos = [];
      state.data.asientos.push(nuevoAsiento);
      saveData("asientos", state.data.asientos);
      state._asientoManualDraft = null;
      state.contabTab = "diario";
      render();
      return;
    }},
  "ver-certificado-retencion": (d, el, e) => {{
      exportCertificadoRetencion(d.id, d.desde, d.hasta);
      return;
    }},
  "export-exogena-csv": (d, el, e) => {{
      exportExogenaCSV();
      return;
    }},
  "new-cuenta-puc": (d, el, e) => {{
      state.editingCuentaPUC = { codigo:"", nombre:"", naturaleza:"D", _isNew:true };
      renderCuentaPUCModal();
      return;
    }},
  "edit-cuenta-puc": (d, el, e) => {{
      const c = (state.data.puc||[]).find(c => c.codigo === d.codigo);
      if (!c) return;
      state.editingCuentaPUC = { ...c, _isNew:false, _original: c.codigo };
      renderCuentaPUCModal();
      return;
    }},
  "delete-cuenta-puc": (d, el, e) => {{
      if (!confirm(`¿Eliminar la cuenta ${d.codigo}? Esto no elimina los asientos ya registrados.`)) return;
      saveData("puc", (state.data.puc||[]).filter(c => c.codigo !== d.codigo));
      render();
      return;
    }},
  "save-cuenta-puc": (d, el, e) => {{
      const c = state.editingCuentaPUC;
      if (!c || !c.codigo || !c.codigo.trim() || !c.nombre || !c.nombre.trim()) {
        alert("⚠️ Código y nombre son obligatorios"); return;
      }
      const puc = [...(state.data.puc||[])];
      if (c._isNew) {
        if (puc.some(x => x.codigo === c.codigo.trim())) { alert("⚠️ Ya existe una cuenta con ese código"); return; }
        puc.push({ codigo:c.codigo.trim(), nombre:c.nombre.trim(), naturaleza:c.naturaleza });
      } else {
        const idx = puc.findIndex(x => x.codigo === c._original);
        if (idx >= 0) puc[idx] = { codigo:c.codigo.trim(), nombre:c.nombre.trim(), naturaleza:c.naturaleza };
      }
      saveData("puc", puc);
      state.modal = null;
      state.editingCuentaPUC = null;
      render();
      return;
    }},
});
